import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import {shortenValue} from "signoxe/components/widgets/EditableLabel"
import './styles.scss';

const DeviceGroupSelect = ({ groups, onChange, selected, setUngroup }) => {
  const [isActive, setIsActive] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  const toggleDropdown = () => {
    console.log("isActive", selected)
    setIsActive(!isActive);
    // if (!isActive) {
    //   inputRef.current.focus();
    // }
  };

  const clearSearch = () => {
    setSearchValue('');
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleGroupSelect = (group) => {
    onChange(group.id);
    toggleDropdown();
    clearSearch();
  };

  const handleUnGroupSelect = (group) => {
    onChange(group);
   
  };

  const filteredGroups = groups.filter((group) =>
    group.name.toLowerCase().includes(searchValue.toLowerCase())
  );
  
  const selectedGroup = groups.find((group) => group.id === selected);

  return (
    <div className="dropdown-container" style={{width:"10rem"}} ref={dropdownRef}>
      <div className="dropdown-input" onClick={() => toggleDropdown()}>
        <div className="dropdown-selected-value" style={{textOverflow:"ellipsis"}}>{selectedGroup ? shortenValue(selectedGroup.name, 15) : '--------'}</div>
        <div className="dropdown-tools">
          <DropDownIcon />
        </div>
      </div>
      {isActive === true && (
        <div className="deviceGroup_dropdownMenu_overlay">
          <div className="dropdown-menu" >
            <div className="dropDown_ItemSearch_overlay">
              <input
                type="text"
                className="dropDown_ItemSearch"
                placeholder="Search..."
                ref={inputRef}
                value={searchValue}
                onChange={handleSearchChange}
              />
            </div>
            {filteredGroups.map((group) => (
              <div
                key={group.id}
                className="dropdown-item"
                onClick={() => handleGroupSelect(group)}
              >
               
                {shortenValue(group.name, 15)}
              </div>
            ))}
            {setUngroup && (
              <div
                className="dropdown-item"
                onClick={() => handleUnGroupSelect('Set Ungrouped')}
              >
                Set Ungrouped
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

DeviceGroupSelect.propTypes = {
  groups: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.object,
  setUngroup: PropTypes.bool.isRequired,
};

const DropDownIcon = () => {
  return (
    <svg height="20" width="20" viewBox="0 0 20 20">
      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
    </svg>
  );
};

export default DeviceGroupSelect;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/DeviceGroupSelect/index.js